import Vue from 'vue'
import { VueMaskDirective } from 'v-mask'
import { ModalPlugin, ToastPlugin } from 'bootstrap-vue'

import { Icon } from '@iconify/vue2'
import './libs/acl'
import './libs/axiosAWS'
import './libs/sweet-alerts'
import VueCompositionAPI from '@vue/composition-api'
// eslint-disable-next-line import/no-extraneous-dependencies
import excel from 'vue-excel-export'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components

import './global-components'
// Or as a directive-only

import '@/libs/portal-vue'
import '@/libs/toastification'
import '@core/scss/vue/libs/toastification.scss'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(excel)

Vue.component('iconfy', Icon)

Vue.directive('mask', VueMaskDirective)
// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
